function clampPct(v, min = 6, max = 94) {
  return Math.min(max, Math.max(min, v));
}

/** Position du reflet blanc (--gx / --gy) pour les boutons .btn-glow */
export function onGlowPointerMove(e) {
  const el = e.currentTarget;
  const r = el.getBoundingClientRect();
  if (!r.width || !r.height) return;
  const x = ((e.clientX - r.left) / r.width) * 100;
  const y = ((e.clientY - r.top) / r.height) * 100;
  el.style.setProperty('--gx', `${clampPct(x)}%`);
  el.style.setProperty('--gy', `${clampPct(y)}%`);
}

export function onGlowPointerLeave(e) {
  e.currentTarget.style.removeProperty('--gx');
  e.currentTarget.style.removeProperty('--gy');
}

export const glowPointerHandlers = {
  onMouseMove: onGlowPointerMove,
  onMouseLeave: onGlowPointerLeave,
};
